<script lang="ts" setup>
import {ExtendedProject, Role} from "@/types";
import {Head, useForm} from "@inertiajs/vue3";
import BaseLayout from "@/layouts/BaseLayout.vue";
import TextField from "@/components/forms/TextField.vue";

interface Props {
    project: ExtendedProject
    role: Role
}
const props = defineProps<Props>()

defineOptions({
    layout: BaseLayout
})

const form = useForm({
    name: '',
    description: '',
})

const submit = () => {
    form.post(route('projects.groups.store', {project: props.project.slug}));
}
</script>

<template>
    <Head title="Create group" />
    <v-row
        :no-gutters="true"
        justify="center"
        class="mt-15"
    >
        <v-col
            cols="10"
            md="6"
            xl="5"
        >
            <v-card :flat="true">
                <v-form @submit.prevent="submit">
                    <v-card-subtitle class="text-h6 text-center">
                        {{ props.project.name }}
                    </v-card-subtitle>
                    <v-card-title class="text-h4 text-center font-weight-bold mb-15">
                        Create a new group
                    </v-card-title>
                    <v-card-text class="pt-1">
                        <v-row class="mt-3">
                            <v-col
                                cols="12"
                                class="py-0"
                            >
                                <text-field
                                    v-model="form.name"
                                    :errors="form.errors.name"
                                    label="Name"
                                    :required="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="mt-3">
                            <v-col
                                cols="12"
                                class="py-0"
                            >
                                <text-field
                                    v-model="form.description"
                                    :errors="form.errors.description"
                                    label="Description"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="px-4">
                        <submit-btn
                            :loading="form.processing"
                            type="submit"
                            :block="true"
                            size="large"
                        >
                            <span class="font-weight-bold">Create group</span>
                        </submit-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-col>
    </v-row>
</template>

<style scoped>

</style>
